<template>
  <div class="nav_div">
    <div class="nav_left">
      <div class="close_div" @click="click_back()">
        <Icon :type="back_icon" size="24" color="white" />
      </div>

      <div class="logo">
        <div class="logo_inner">
          <img class="logo_img" src="@/assets/image/auth/logo_white.png" alt="" />

          <span class="logo_txt" @click="click_title">{{ title }}</span>
        </div>

        <span class="bias">/</span>

        <span class="sys_name" @click="click_sys_name">{{ sys_name02 }}</span>

        <span class="bias">/</span>

        <span class="page_name">{{ nav_name }}</span>

        <!-- 头部链接 -->
        <div class="top_link" v-if="top_link_list.length > 0">
          <span class="top_split_txt"> | </span>
          <div class="top_link_div">
            <div draggable="true" @dragstart="dragStart(index, $event)" @drop="drop(index, $event)" @dragover.prevent
              @dragenter.prevent :class="item.is_select == 1 ? 'top_link2_1' : 'top_link2'"
              v-for="(item, i) in top_link_list" :key="i" @click="click_top_link(item, i)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="userinfo_div">
      <div class="tongzhi_icon_div" @click="click_msg" title="消息中心">
        <span class="iconfont icontongzhi tongzhi_icon"></span>

        <span class="tongzhi_count" style="right: -5px" v-if="msg_count > 0 && msg_count < 10">{{ msg_count }}</span>

        <span class="tongzhi_count" style="right: -10px" v-if="msg_count > 10 && msg_count < 99">{{ msg_count }}</span>

        <span class="tongzhi_count" style="right: -15px" v-if="msg_count > 99">{{
          msg_count
        }}</span>
      </div>

      <div class="user_info_main" @click="click_user_info" title="个人中心">
        <div class="userinfo_div_img">
          <img :src="userinfo.avatar" class="avatar" alt="" />
        </div>

        <span class="username">{{ userinfo.name }}</span>
      </div>
    </div>

    <!-- 播放音频 -->

    <audio id="notify_mp3_url" controls v-if="notify_mp3_show">
      <source :src="notify_mp3_url" type="audio/mpeg" />
    </audio>
    <div class="watermark_div" v-if="userinfo.watermark_txt ">
      <Watermark :content="userinfo.watermark_txt" :rotate="-30" :z-index="1000" :textStyle="userinfo.watermark_text_style" ></Watermark>
    </div>

  </div>
</template>

<script>
import { open_new_page, http } from "@/utils/http";
import Watermark from '@/component/watermark/watermark.vue'

import ReconnectingWebSocket from "reconnecting-websocket";


export default {
  name: "menu2",
  props: ["page_name", "back_icon", "back_type", 'sys_name'],
  components: {
    Watermark
  },
  data() {
    return {
      title: process.env.VUE_APP_TITLE,
      sys_name01: process.env.VUE_APP_SYS_NAME,
      sys_name02: '',
      nav_name: "",
      // watermark_txt:"水印内容",
      //   page_name: "我的项目",

      //
      userinfo: {},

      //定时刷新数量
      get_msg_count_timer: null,
      msg_count: 0,

      //   消息通知声音
      notify_mp3_show: false,
      notify_mp3_url: "",

      //   ws实例
      rws: {},

      // 头部链接
      top_link_list: [],
      drag: false,
      current_drag: {},
    };
  },

  activated() {
    //获取收藏
    this.get_collect();
  },
  mounted() {
    this.get_user_data();
    //
    this.get_mp3_notify();
    //
    this.get_msg_count();
    this.msg_count_timer();

    var meta = this.$route.meta;
    console.log(meta);
    if (this.page_name) {
      this.nav_name = this.page_name;
    } else {
      this.nav_name = meta.title;
    }

    if (this.sys_name) {
      this.sys_name02 = this.sys_name
    } else {
      this.sys_name02 = this.sys_name01
    }

    //获取收藏
    this.get_collect();
  },

  beforeDestroy() {
    // 在组件销毁前清除定时器
    clearInterval(this.get_msg_count_timer);
    this.get_msg_count_timer = null;

    console.log("关闭websokcet");
    that.rws.close();
  },

  methods: {
    drop(index, event) {
      // 获取改变的下标
      const dropTarget = event.target.closest(".top_link_div > div"); // 找到最近的拖动目标元素
      const dropIndex = Array.from(dropTarget.parentNode.children).indexOf(dropTarget); // 计算目标索引
      console.log(dropIndex, dropTarget);
      var new_list = [];
      for (var i = 0; i < this.top_link_list.length; i++) {
        if (this.top_link_list[i]["id"] == this.current_drag.id) {
          continue;
        } else {
          new_list.push(this.top_link_list[i]);
        }
      }

      new_list.splice(dropIndex, 0, this.current_drag);
      console.log(new_list);
      var weight_obj = {};
      for (var i = 0; i < new_list.length; i++) {
        weight_obj[new_list[i].id] = i;
      }
      console.log(weight_obj);

      var that = this;
      var obj = {
        weight_dict: weight_obj,
      };
      http(
        "post",
        process.env.VUE_APP_V2_AUTH_HOST + "/staff/user_index/v2/update_collect_weight",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.get_collect();
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.menu_loading = false;
          console.log(res, "请求出错");
        });
    },
    dragStart(index, event) {
      const dropTarget = event.target.closest(".top_link_div > div"); // 找到最近的拖动目标元素
      const dropIndex = Array.from(dropTarget.parentNode.children).indexOf(dropTarget); // 计算目标索引
      // console.log(dropIndex,dropTarget)
      this.current_drag = this.top_link_list[dropIndex];
    },

    click_title() {
      var url = process.env.VUE_APP_V2_INDEX_URL + "?page=workbench";
      console.log(url);
      open_new_page(url, "_self");
    },
    click_sys_name() {
      var url = process.env.VUE_APP_V2_INDEX_URL + "?page=workbench";
      console.log(url);
      open_new_page(url, "_self");
    },

    // 获取收藏
    get_collect() {
      var that = this;
      var obj = {
        host: window.location.host,
      };
      http(
        "post",
        process.env.VUE_APP_V2_AUTH_HOST + "/staff/user_index/v2/my_collect_link",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.top_link_list = res.data.link_list;
            //刷新头部
            that.refresh_top_link();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.menu_loading = false;
          console.log(res, "请求出错");
        });
    },

    //刷新头部链接
    refresh_top_link() {
      var path = this.$route.path;
      console.log(path);
      for (var i = 0; i < this.top_link_list.length; i++) {
        var link_path = this.top_link_list[i]["path"];
        console.log(88888, link_path);

        if (path == link_path) {
          this.top_link_list[i]["is_select"] = 1;
        } else {
          this.top_link_list[i]["is_select"] = 0;
        }
      }
    },

    //获取通知音乐
    get_mp3_notify() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_V2_AUTH_HOST + "/message/notify_mp3", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.notify_mp3_url = res.data.mp3_url;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.menu_loading = false;
          console.log(res, "请求出错");
        });
    },

    //获取消息数量
    msg_count_timer() {
      console.log("循环获取消息");
      var that = this;
      if (!this.get_msg_count_timer) {
        //获取消息数量
        this.get_msg_count_timer = setInterval(() => {
          //   console.log("循环");
          //获取消息数量
          var cookie_msg_count = that.$cookies.get("dx_msg_count");

          that.msg_count = cookie_msg_count;
        }, 1000);
      }
    },

    msg_notify() {
      var that = this;
      // 播放音乐
      this.notify_mp3_show = false;
      setTimeout(function () {
        that.notify_mp3_show = true;
      }, 100);

      setTimeout(function () {
        var audioElement = document.getElementById("notify_mp3_url");
        audioElement.play().catch((error) => {
          console.log(error);
          console.log("通知声音没有播放");
        });
      }, 500);
    },

    //显示消息
    show_message_notify() {
      var that = this;
      setTimeout(function () {
        that.$Notice.config({
          top: 50,
          duration: 2,
        });
        that.$Notice.warning({
          title: "您收到一条新消息，请及时查看！",
          desc: "",
        });
      }, 1000);
    },

    // 获取消息数量
    get_msg_count() {
      var that = this;
      var dx_token = this.$cookies.get("dx_token");
      const url =
        process.env.VUE_APP_V2_AUTH_MESSAGE_WS +
        "/message/ws/message_count?token=" +
        dx_token;
      console.log(url);
      const protocols = []; // 可选的子协议数组
      const options = {
        // 自动重新连接的选项（可选）
        connectionTimeout: 2000,
        maxRetries: 10,
      };

      that.rws = new ReconnectingWebSocket(url, protocols, options);

      // 当连接成功建立时
      that.rws.addEventListener("open", function (event) {
        console.log("Connected to the WebSocket server");
      });

      // 当接收到消息时
      that.rws.addEventListener("message", function (event) {
        // console.log("Received message:", event.data);
        var msg_data = JSON.parse(event.data);
        var msg_count = msg_data.msg_count;
        that.$cookies.set("dx_msg_count", msg_count);
        if (msg_count > that.msg_count) {
          console.log("消息声音通知", msg_count, that.msg_count);
          that.show_message_notify();
          // that.msg_notify();
        }
      });

      // 当连接关闭时
      that.rws.addEventListener("close", function (event) {
        console.log("Disconnected from the WebSocket server");
      });

      // 当发生错误时
      that.rws.addEventListener("error", function (event) {
        console.error("WebSocket encountered error:", event.error);
      });
    },

    // 获取用户信息
    get_user_data() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_V2_AUTH_HOST + "/staff/user_index/v2/nav_user_info",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.userinfo = res.data.user_info;
            
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.menu_loading = false;
          console.log(res, "请求出错");
        });
    },

    //点击返回
    click_back() {
      if (this.back_type == null || this.back_type == "close") {
        // 关闭窗口
        window.close()

      }

      if (this.back_type == "back") {
        if (window.history.length > 1) {
          this.$router.go(-1);
        } else {
          var index_url = process.env.VUE_APP_V2_INDEX_URL + "?page=workbench";
          open_new_page(index_url, "_self");
        }
      }
    },

    //点击消息
    click_msg() {
      var index_url = process.env.VUE_APP_V2_INDEX_URL + "?page=message";
      open_new_page(index_url, "_self");
    },

    //点击用户头像
    click_user_info() {
      var index_url = process.env.VUE_APP_V2_INDEX_URL + "?page=uinfo";
      open_new_page(index_url, "_self");
    },

    //点击头部链接
    click_top_link(item, i) {
      open_new_page(item.url, "_self");
    },
  },
};
</script>

<style scoped>
.watermark_div {
  box-sizing: border-box;
  /* 确保内边距不影响尺寸 */
  position: fixed;
  width: 100vw;
  height: 100vh;
  margin: 0;
  /* 重置外边距 */
  padding: 0;
  /* 重置内边距 */
  /* background-color: red; */
  z-index: 99999;
  top: 0;
  left: 0;
  pointer-events: none
}

.top_link_div {
  display: flex;
  align-items: center;
}

.top_link2 {
  font-size: 13px;
  cursor: pointer;
  color: #b1b1b1;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}

.top_link2_1 {
  font-size: 13px;
  cursor: pointer;
  color: #f4f4f4;
  background: #105ab4;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}

.top_link2:hover {
  color: rgb(223, 217, 217);
  background: #104a919d;
}

.top_split_txt {
  color: #f0f0f03e;
  margin: 0 10px 0 10px;
}

.top_link {
  margin: 10px;
  display: flex;
  align-items: center;
}

.user_info_main {
  display: flex;
  align-items: center;
}

#notify_mp3_url {
  display: none;
}

.tongzhi_count {
  background: red;
  color: #fff;
  font-size: 10px;
  position: absolute;
  top: 0;
  padding: 1px 8px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tongzhi_icon_div {
  margin-right: 25px;
  padding: 0 10px;
  position: relative;
}

.tongzhi_icon {
  color: #f2f2f2;
  font-size: 20px;
}

.userinfo_div_img {
  margin-right: 5px;
  padding-top: 5px;
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #ccc;
}

.userinfo_div {
  display: flex;
  align-items: center;
  padding: 0 20px;
  cursor: pointer;
}

.username {
  color: #f2f2f2;
}

.bias {
  color: #9591c8;
}

.logo_inner {
  display: flex;
  align-items: center;
}

.logo_img {
  width: 28px;
  height: 28px;
  margin-bottom: 3px;
  margin-right: 5px;
}

.logo_txt {
  cursor: pointer;
  margin-right: 5px;
  font-size: 14px;
}

.logo_txt:hover {
  font-weight: 600;
  color: #fff;
}

.page_name {
  font-size: 14px;
  margin-left: 5px;
  cursor: pointer;
}

.page_name:hover {
  font-weight: 600;
  color: #fff;
}

.sys_name {
  padding: 0 5px;
  cursor: pointer;
  font-size: 14px;
}

.sys_name:hover {
  font-weight: 600;
  color: #fff;
}

.logo {
  color: #e3e3e3;
  font-size: 16px;
  margin: 0 10px;
  display: flex;
  align-items: center;
}

.nav_left {
  display: flex;
  align-items: center;
}

.close_div {
  height: 40px;
  width: 50px;
  justify-content: center;
  display: flex;
  align-items: center;
  background: #1957a2;
  cursor: pointer;
}

.close_div:hover {
  background: rgb(221, 1, 1);
}

.nav_div {
  height: 40px;
  background: #003576;
  position: absolute;
  width: 100%;
  top: 0;
  box-shadow: 0 3px 3px #dbdbdb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
